import { render, staticRenderFns } from "./modalCrearProveedor.vue?vue&type=template&id=637497d0&scoped=true&"
import script from "./modalCrearProveedor.vue?vue&type=script&lang=js&"
export * from "./modalCrearProveedor.vue?vue&type=script&lang=js&"
import style0 from "./modalCrearProveedor.vue?vue&type=style&index=0&id=637497d0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637497d0",
  null
  
)

export default component.exports